import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { PRICE_TEASER, selectTopic } from "../../data/content";

const PlainPrices = () => (
  <div data-testid="price-teaser-compare" className="rounded-3xl bg-[#161616] text-white p-6 md:p-8 shadow-[0_30px_60px_-30px_rgba(22,22,22,0.6)]">
    <p className="font-head text-xs font-bold uppercase tracking-[0.14em] text-white/50">Was es kostet</p>
    <ul className="mt-4 divide-y divide-white/10">
      {PRICE_TEASER.plain.map(([name, price, sub], i) => (
        <li key={name} data-testid={`price-teaser-item-${i}`} className="py-3.5 flex flex-col sm:flex-row items-start justify-between gap-1 sm:gap-4">
          <span className="text-sm text-white min-w-0">{name}<span className="block text-xs text-white/60">{sub}</span></span>
          <span data-testid={`price-teaser-price-${i}`} className={`font-head font-bold leading-none whitespace-nowrap shrink-0 ${i === 0 ? "text-[#E9B3EE] text-2xl" : "text-lg"}`}>{price}</span>
        </li>
      ))}
    </ul>
    <button type="button" data-testid="price-teaser-cta" onClick={() => selectTopic("einsteiger")} className="tap mt-6 w-full inline-flex justify-center items-center gap-1.5 rounded-full bg-[#BA00C5] px-5 py-3 text-sm font-head font-semibold text-white hover:bg-[#9E00A8] transition-colors">Erst kostenlos ausprobieren <ArrowRight size={14} /></button>
    <Link to="/preise" data-testid="price-teaser-link" className="tap mt-4 flex justify-center items-center gap-1.5 text-sm font-semibold text-white/80 underline underline-offset-4 decoration-white/30 hover:text-white">{PRICE_TEASER.cta} <ArrowRight size={14} /></Link>
  </div>
);

export const PriceTeaser = () => (
  <section id="preis-teaser" data-testid="section-price-teaser" className="py-12 md:py-16 bg-white border-y border-[#E6E3DD]">
    <div className="max-w-[1320px] mx-auto px-5 md:px-10 grid lg:grid-cols-[1.2fr_1fr] gap-6 md:gap-10 lg:gap-20 items-center">
      <Reveal>
        <p className="eyebrow mb-3" data-testid="price-teaser-eyebrow">{PRICE_TEASER.eyebrow}</p>
        <h2 data-testid="price-teaser-heading" className="h-display text-2xl sm:text-3xl lg:text-4xl">{PRICE_TEASER.title} <span className="text-[#BA00C5]">{PRICE_TEASER.accent}</span></h2>
        <p className="mt-4 text-base md:text-lg muted max-w-xl leading-relaxed">{PRICE_TEASER.text}</p>
        <ul data-testid="price-teaser-points" className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3 max-w-xl text-sm font-head font-semibold">
          {["Fester Platz im gecoachten Kurs", "Open Gym in jedem Tarif", "Keine Aufnahmegebühr", "Monatlich kündbar mit Flex"].map((t) => <li key={t} className="flex items-center gap-2"><Check size={16} className="shrink-0 text-[#BA00C5]" aria-hidden="true" />{t}</li>)}
        </ul>
      </Reveal>
      <Reveal delay={0.1} className="w-full max-w-md lg:justify-self-end"><PlainPrices /></Reveal>
    </div>
  </section>
);
